import type { InputHTMLAttributes } from "react";

export function Input({ className = "", ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={[
        "w-full px-3 py-2 text-sm rounded-md bg-[var(--color-bg)] border border-[var(--color-border)]",
        "text-[var(--color-text)] placeholder:text-[var(--color-text-subtle)]",
        "focus:outline-none focus:border-[rgba(139,92,246,0.6)]",
        "disabled:opacity-50",
        className,
      ].join(" ")}
      {...rest}
    />
  );
}
